var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SplashScreen"},[_c('div',{staticClass:"SplashScreen__content"},[_c('img',{attrs:{"src":require("../assets/images/splash.png"),"alt":"Un singe avec un chapeau de marin tenant une bouteille de vin avec une référence à Walt Whitman…"}})])])
}]

export { render, staticRenderFns }